import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e991949"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ai-tools-container"
};
const _hoisted_2 = {
  class: "ai-tools-header"
};
const _hoisted_3 = {
  class: "header-left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "page-title"
}, "AI 工具导航", -1));
const _hoisted_5 = {
  class: "tools-count"
};
const _hoisted_6 = {
  class: "global-search"
};
const _hoisted_7 = {
  class: "modules-container"
};
const _hoisted_8 = {
  class: "module-header"
};
const _hoisted_9 = {
  class: "module-title"
};
const _hoisted_10 = {
  class: "tools-grid"
};
const _hoisted_11 = ["content", "effect", "disabled"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "tool-icon"
};
const _hoisted_14 = {
  class: "tool-info"
};
const _hoisted_15 = {
  key: 0,
  class: "tool-url"
};
const _hoisted_16 = {
  key: 1,
  class: "tool-desc"
};
const _hoisted_17 = {
  key: 2,
  class: "tool-url no-url"
};
const _hoisted_18 = {
  class: "module-section"
};
const _hoisted_19 = {
  class: "module-header"
};
const _hoisted_20 = {
  class: "module-title"
};
const _hoisted_21 = {
  class: "tools-grid"
};
const _hoisted_22 = ["content", "effect", "disabled"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "tool-icon"
};
const _hoisted_25 = {
  class: "tool-info"
};
const _hoisted_26 = {
  key: 0,
  class: "tool-url"
};
const _hoisted_27 = {
  key: 1,
  class: "tool-desc"
};
const _hoisted_28 = {
  key: 2,
  class: "tool-url no-url"
};
import { ref, onMounted, watch } from 'vue';
import { Search, Link } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import ToolDescription from './ToolDescription.vue';
import aiVarOne from '../json/aiOne.js';
import aiTwo from '../json/aiTwo.js';
import aiThree from '../json/aiThree.js';
import aiFour from '../json/aiFour.js';
import aiFive from '../json/aiFive.js';
import aiSix from '../json/aiSix.js';
import aiSevne from '../json/aiSevne.js';
import aiEight from '../json/aiEight.js';
import aiNine from '../json/aiNine.js';
import aiTen from '../json/aiTen.js';

// 全局搜索和活动标签页

export default {
  __name: 'AI',
  setup(__props) {
    const globalSearchQuery = ref('');
    const activeTab = ref('all');
    const toolTipEffect = ref('dark');

    // 工具数据模块 - 增加了description字段用于描述和提示
    const toolModules = ref([{
      "title": "AI 热门AI工具",
      "searchQuery": "",
      "tools": aiVarOne,
      "filteredTools": []
    }, {
      "title": "AI 对话工具",
      "searchQuery": "",
      "tools": aiTwo,
      "filteredTools": []
    }, {
      "title": "AI 写作工具",
      "searchQuery": "",
      "tools": aiThree,
      "filteredTools": []
    }, {
      "title": "AI 编程工具",
      "searchQuery": "",
      "tools": aiFour,
      "filteredTools": []
    }, {
      "title": "AI 设计工具",
      "searchQuery": "",
      "tools": aiFive,
      "filteredTools": []
    }, {
      "title": "AI 3D工具",
      "searchQuery": "",
      "tools": aiSix,
      "filteredTools": []
    }, {
      "title": "AI 提示词工具",
      "searchQuery": "",
      "tools": aiSevne,
      "filteredTools": []
    }, {
      "title": "AI 图工具",
      "searchQuery": "",
      "tools": aiEight,
      "filteredTools": []
    }, {
      "title": "AI 模型训练工具",
      "searchQuery": "",
      "tools": aiNine,
      "filteredTools": []
    }, {
      "title": "AI 音视频工具",
      "searchQuery": "",
      "tools": aiTen,
      "filteredTools": []
    }
    // {
    //   "title": "AI设计工具",
    //   "searchQuery": "",
    //   "tools": [],
    //   "filteredTools": []
    // },
    // ...保留其他工具模块
    ]);

    // 在onMounted中初始化过滤后的工具列表
    onMounted(() => {
      // 初始化所有模块的过滤工具列表
      toolModules.value.forEach(module => {
        module.filteredTools = [...module.tools];
      });

      // 添加工具卡片动画延迟
      setTimeout(() => {
        const cards = document.querySelectorAll('.tool-card');
        cards.forEach((card, index) => {
          card.style.setProperty('--index', index % 10);
        });
      }, 100);
    });

    // 获取工具图标URL
    const getIconUrl = tool => {
      if (!tool.icon) return '';

      // 如果是完整的URL，直接返回
      if (tool.icon.startsWith('http')) {
        return tool.icon;
      }

      // 否则加载本地图标
      try {
        return `${window.location.origin}/${tool.icon}`; // new URL(`${tool.icon}`, import.meta.url).href;
      } catch (e) {
        console.warn(`Icon not found: ${tool.icon}`);
        return '';
      }
    };

    // 格式化URL显示
    const formatUrl = url => {
      if (!url) return '';
      try {
        const urlObj = new URL(url);
        return urlObj.hostname;
      } catch (e) {
        return url;
      }
    };

    // 打开工具URL
    const openToolUrl = tool => {
      if (!tool.url) {
        ElMessage({
          message: '该工具暂无可访问的链接',
          type: 'info'
        });
        return;
      } else if (tool.isVpn) {
        ElMessage({
          message: '该网站需要外网工具才能访问，访问前请先确认已打开外网访问工具',
          type: 'info'
        });
        setTimeout(() => {
          window.open(tool.url, '_blank');
        }, 2000);
      } else {
        window.open(tool.url, '_blank');
      }
    };

    // 获取工具描述用于tooltip
    const getToolDescription = tool => {
      return tool.description || '暂无描述';
    };

    // 截断描述文本，保持适当长度
    const truncateDescription = (text, maxLength = 60) => {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    };

    // 获取工具总数
    const getTotalToolsCount = () => {
      return toolModules.value.reduce((count, module) => count + module.tools.length, 0);
    };

    // 过滤模块内的工具
    const filterModuleTools = module => {
      if (!module.searchQuery) {
        module.filteredTools = [...module.tools];
        return;
      }
      const query = module.searchQuery.toLowerCase();
      module.filteredTools = module.tools.filter(tool => tool.name.toLowerCase().includes(query) || tool.description && tool.description.toLowerCase().includes(query));
    };

    // 全局搜索处理
    const handleGlobalSearch = () => {
      if (!globalSearchQuery.value) {
        // 如果清空搜索，重置所有模块的过滤工具
        toolModules.value.forEach(module => {
          module.filteredTools = [...module.tools];
          module.searchQuery = '';
        });
        return;
      }
      const query = globalSearchQuery.value.toLowerCase();

      // 对每个模块应用全局搜索
      toolModules.value.forEach(module => {
        module.filteredTools = module.tools.filter(tool => tool.name.toLowerCase().includes(query) || tool.description && tool.description.toLowerCase().includes(query));
      });
    };

    // 监听全局搜索变化
    watch(globalSearchQuery, newValue => {
      if (!newValue) {
        // 当全局搜索清空时，重置所有模块的工具列表
        toolModules.value.forEach(module => {
          module.filteredTools = [...module.tools];
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ToolDescription, {
        title: "AI 工具导航使用说明",
        description: "本页面收集了各类优质AI工具，便于您快速查找和使用。每个工具都配有功能描述和直接访问链接。",
        features: [{
          title: '分类浏览',
          description: '通过顶部标签页可以按照不同分类浏览工具'
        }, {
          title: '智能搜索',
          description: '支持通过工具名称和功能描述搜索，快速找到所需工具'
        }, {
          title: '工具详情',
          description: '鼠标悬停在工具卡片上可查看详细功能描述'
        }, {
          title: '一键访问',
          description: '点击工具卡片或访问按钮，即可打开对应工具网站'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, "共 " + _toDisplayString(getTotalToolsCount()) + " 个工具", 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_input, {
        modelValue: globalSearchQuery.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => globalSearchQuery.value = $event),
        placeholder: "搜索全部AI工具...",
        class: "global-search-input",
        clearable: "",
        onInput: handleGlobalSearch
      }, {
        prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Search))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createVNode(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => activeTab.value = $event),
        type: "card",
        class: "module-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "全部工具",
          name: "all"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toolModules.value, (module, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "module-section"
            }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h2", _hoisted_9, _toDisplayString(module.title), 1), _createVNode(_component_el_input, {
              modelValue: module.searchQuery,
              "onUpdate:modelValue": $event => module.searchQuery = $event,
              placeholder: "在此分类中搜索",
              clearable: "",
              class: "module-search",
              onInput: $event => filterModuleTools(module)
            }, {
              prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Search))]),
                _: 1
              })]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onInput"])]), _createElementVNode("div", _hoisted_10, [module.filteredTools.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "没有找到匹配的工具"
            })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.filteredTools, (tool, toolIndex) => {
              return _openBlock(), _createElementBlock("div", {
                key: toolIndex,
                content: getToolDescription(tool),
                placement: "top",
                effect: toolTipEffect.value,
                disabled: !tool.description
              }, [_createElementVNode("div", {
                class: "tool-card",
                onClick: $event => openToolUrl(tool),
                style: _normalizeStyle({
                  '--index': toolIndex
                })
              }, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_avatar, {
                size: 50,
                src: getIconUrl(tool),
                fit: "cover",
                alt: tool.name
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(tool.name.charAt(0)), 1)]),
                _: 2
              }, 1032, ["src", "alt"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("h3", {
                class: _normalizeClass(["tool-name", {
                  'highlight': false
                }])
              }, _toDisplayString(tool.name), 1), tool.url ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(formatUrl(tool.url, tool.isVpn)), 1)) : _createCommentVNode("", true), tool.description ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(truncateDescription(tool.description, 60)), 1)) : !tool.url ? (_openBlock(), _createElementBlock("div", _hoisted_17, "暂无链接")) : _createCommentVNode("", true)]), tool.url ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "tool-action",
                type: "primary",
                text: "",
                onClick: _withModifiers($event => openToolUrl(tool), ["stop"])
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(Link))]),
                  _: 1
                }), _createTextVNode(" 访问 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 12, _hoisted_12)], 8, _hoisted_11);
            }), 128))])]);
          }), 128))])]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toolModules.value, (module, index) => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: index,
            label: module.title,
            name: 'tab-' + index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("h2", _hoisted_20, _toDisplayString(module.title), 1), _createVNode(_component_el_input, {
              modelValue: module.searchQuery,
              "onUpdate:modelValue": $event => module.searchQuery = $event,
              placeholder: "在此分类中搜索",
              clearable: "",
              class: "module-search",
              onInput: $event => filterModuleTools(module)
            }, {
              prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Search))]),
                _: 1
              })]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onInput"])]), _createElementVNode("div", _hoisted_21, [module.filteredTools.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "没有找到匹配的工具"
            })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.filteredTools, (tool, toolIndex) => {
              return _openBlock(), _createElementBlock("div", {
                key: toolIndex,
                content: getToolDescription(tool),
                placement: "top",
                effect: toolTipEffect.value,
                disabled: !tool.description
              }, [_createElementVNode("div", {
                class: "tool-card",
                onClick: $event => openToolUrl(tool),
                style: _normalizeStyle({
                  '--index': toolIndex
                })
              }, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_avatar, {
                size: 50,
                src: getIconUrl(tool),
                fit: "cover",
                alt: tool.name
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(tool.name.charAt(0)), 1)]),
                _: 2
              }, 1032, ["src", "alt"])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("h3", {
                class: _normalizeClass(["tool-name", {
                  'highlight': false
                }])
              }, _toDisplayString(tool.name), 1), tool.url ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(formatUrl(tool.url, tool.isVpn)), 1)) : _createCommentVNode("", true), tool.description ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(truncateDescription(tool.description, 60)), 1)) : !tool.url ? (_openBlock(), _createElementBlock("div", _hoisted_28, "暂无链接")) : _createCommentVNode("", true)]), tool.url ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "tool-action",
                type: "primary",
                text: "",
                onClick: _withModifiers($event => openToolUrl(tool), ["stop"])
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(Link))]),
                  _: 1
                }), _createTextVNode(" 访问 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 12, _hoisted_23)], 8, _hoisted_22);
            }), 128))])])]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};